import { NavigationSlider } from '@yes.technology/react-toolkit'
import styled from 'styled-components'

export const StickyArea = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
`

export const StyledNavigationSlider = styled(NavigationSlider)`
  > div > div {
    @media (max-width: 768px) {
      justify-content: center;
    }
  }
`
